<div class="details-body-wrapper" *ngIf="entityUuid">
  <app-ai-usage-list
    [entity_id]="entityUuid"
    [entity_type]="'provider'"
  ></app-ai-usage-list>
</div>
